import { isConnectorBitPerfectBlocked } from './connectorCapability';

export type ConfirmedOutputPath = 'exclusive' | 'shared';

export interface OutputPathBadgeInput {
  usbOutputPath: 'exclusive' | 'shared' | null;
  isLocalNativeZone: boolean;
  /** playing | loading | buffering */
  isPlaybackLive: boolean;
  exclusiveEngineActive: boolean;
  exclusiveSuppressed: boolean;
}

/**
 * Actual playback output path for badge labeling — never zone intent alone.
 * Bit-Perfect only when exclusive dispatch succeeded and engine is active (or store confirms).
 * Kill-switch suppression and runExclusiveSharedFallback both yield "shared".
 */
export function resolveConfirmedOutputPath(
  input: OutputPathBadgeInput,
): ConfirmedOutputPath | null {
  if (!input.isPlaybackLive) return null;

  if (input.exclusiveSuppressed) {
    if (input.isLocalNativeZone || input.usbOutputPath === 'shared') {
      return 'shared';
    }
    if (input.usbOutputPath === 'exclusive') {
      return 'shared';
    }
    return null;
  }

  if (input.usbOutputPath === 'shared') { // before engine-active: Connector output_mode 'shared' runs the engine via the mixer (#10426-a1)
    return 'shared';
  }

  if (input.exclusiveEngineActive || input.usbOutputPath === 'exclusive') {
    return 'exclusive';
  }

  if (input.isLocalNativeZone) {
    return 'shared';
  }

  return null;
}

export function formatOutputPathSuffix(
  t: (key: string) => string,
  input: OutputPathBadgeInput,
): string {
  const path = resolveConfirmedOutputPath(input);
  if (path === 'exclusive') return ` · ${t('exclusive.bit_perfect')}`;
  if (path === 'shared') return ` · ${t('exclusive.shared_output')}`;
  return '';
}

/** Zone picker subtitle for local-native (USB DAC) rows. */
export function localNativePickerSubtitle(t: (key: string) => string): string {
  if (isConnectorBitPerfectBlocked()) {
    return t('player.bit_perfect_direct_tag_suppressed');
  }
  return t('player.bit_perfect_direct_tag');
}
